import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ModeratorService } from 'src/app/shared/moderator/moderator.service';
import { LoginService } from 'src/app/shared/user-login/login.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-get-customers-add-credit',
    templateUrl: './get-customers-add-credit.component.html',
    styleUrls: ['./get-customers-add-credit.component.css'],
    standalone: false
})
export class GetCustomersAddCreditComponent implements OnInit {

  role
  customers: []
  experts: []
  serverErrorMessages: string
  loading: boolean = true;
  closeResult;
  purposes = ["Subscription", "AMC", "Calibration", "Initial Deposit"]
  creditForm = new FormGroup({
    creditToBeAdded : new FormControl(1, [Validators.required, Validators.min(0)]),
    purpose : new FormControl(''),
    payment_reference : new FormControl('', [Validators.required]),
    payment_mode : new FormControl(''),
    date_of_payment : new FormControl('', [Validators.required]),
    summary : new FormControl('', [Validators.required])
  });
  creditPerTransactionForm = new FormGroup({
    perTransactionCredit: new FormControl(1, [Validators.required]),
    hw_maintenance: new FormControl(1, [Validators.required]),
    calibration: new FormControl(1, [Validators.required]),
    AMC: new FormControl(1, [Validators.required]),
    support: new FormControl(1, [Validators.required]),
  });
  creditPerTransactionFormExpert = new FormGroup({
    credit: new FormControl(1, [Validators.required]),
  })
  customer:{}
  expert:{}
  currentCT
  pdfLoading: boolean = false
  constructor(private loginService: LoginService,private router : Router, private moderatorService: ModeratorService, private modalService: NgbModal,private datePipe: DatePipe) {
    this.checkForm();
  }
  checkForm() {
    this.creditForm.get('creditToBeAdded').valueChanges.subscribe(
      val => {
        ////console.log(val)
        if(val<1){
          this.creditForm.get('creditToBeAdded').setValue(1)
        }
      }
    )
    this.creditPerTransactionForm.get('perTransactionCredit').valueChanges.subscribe(
      val => {
        // console.log(val)
        if(val<1){
          this.creditPerTransactionForm.get('perTransactionCredit').setValue(1)
        }
      }
    )
    this.creditPerTransactionFormExpert.get('credit').valueChanges.subscribe(
      val => {
        // console.log(val)
        if(val<1){
          this.creditPerTransactionFormExpert.get('credit').setValue(1)
        }
      }
    )
    this.creditPerTransactionForm.get('hw_maintenance').valueChanges.subscribe(
      val => {
        // console.log(val)
        if(val<1){
          this.creditPerTransactionForm.get('hw_maintenance').setValue(1)
        }
      }
    )
    this.creditPerTransactionForm.get('calibration').valueChanges.subscribe(
      val => {
        // console.log(val)
        if(val<1){
          this.creditPerTransactionForm.get('calibration').setValue(1)
        }
      }
    )
    this.creditPerTransactionForm.get('AMC').valueChanges.subscribe(
      val => {
        ////console.log(val)
        if(val<1){
          this.creditPerTransactionForm.get('AMC').setValue(1)
        }
      }
    )
    this.creditPerTransactionForm.get('support').valueChanges.subscribe(
      val => {
        // console.log(val)
        if(val<1){
          this.creditPerTransactionForm.get('support').setValue(1)
        }
      }

    )
      

    //this.creditPerTransactionForm.get('amount').setValue(amount);


  }

  ngOnInit(): void {
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
          this.getAllCustomers();
          this.getAllExperts();
          this.loading = false;
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
          this.loading = false;
        }
      )
    }
  }

  getAllCustomers(){
    this.moderatorService.getAllCustomer().subscribe(
      res=>{
       console.log('got all customers', res)
        this.customers = res['customers']
      },
      err=>{
       //console.log('error while getting all customers', err)
      }
    )
  }

  getAllExperts(){
    this.moderatorService.getAllExperts().subscribe(
      res=>{
       //console.log('got all experts', res)
        this.experts = res['techExperts']
       //console.log(this.experts)
      },
      err=>{
       //console.log('error while getting all experts', err)
      }
    )
  }


  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
     //console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

  open(content, customer, modalId) {
    if (modalId==2) {
      this.creditPerTransactionForm.reset();
      this.customer = customer;
      this.getPaymentInfoCustomer();
    }
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.customer = customer
     //console.log('got customer', this.customer)
      this.closeResult = `Closed with: ${result}`;
     //console.log(this.closeResult)
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     //console.log(this.closeResult)
    });
  }

  openExpert(content, expert){
    this.expert = expert
    this.creditPerTransactionFormExpert.reset();
    console.log('got expert', this.expert)
    this.getCreditPerTransactionExpert()
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
     //console.log(this.closeResult)
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     //console.log(this.closeResult)
    });
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  addCredit(){
    console.log(this.creditForm)
    this.moderatorService.addCreditToCustomer({...this.creditForm.getRawValue(), customerId:this.customer['_id']}).subscribe(
      res=>{
       //console.log('successfully added credit', res);
        window.alert(res)
      },
      err => {
       //console.log('error adding credit', err)
      }
    )
  }

  addPaymentInfoCustomer(){
    console.log(this.creditPerTransactionForm.getRawValue());
    this.moderatorService.addPaymentInfo({customerId:this.customer['_id'], infoObject : this.creditPerTransactionForm.getRawValue()}).subscribe(
      res => {
       //console.log(res)
        window.alert(res)
      },
      err => {
       //console.log('error adding creit per transaction', err)
      }
    )
  }

  getPaymentInfoCustomer(){
    this.moderatorService.getPaymentInfo({customerId:this.customer['_id']}).subscribe(
      res => {
        console.log(res)
        if (res['paymentInfo'] && res['paymentInfo']['perTransactionCredit']) this.creditPerTransactionForm.get('perTransactionCredit').setValue(res['paymentInfo']['perTransactionCredit']);
        if (res['paymentInfo'] && res['paymentInfo']['support']) this.creditPerTransactionForm.get('support').setValue(res['paymentInfo']['support']);
        if (res['paymentInfo'] && res['paymentInfo']['AMC']) this.creditPerTransactionForm.get('AMC').setValue(res['paymentInfo']['AMC']);
        if (res['paymentInfo'] && res['paymentInfo']['hw_maintenance']) this.creditPerTransactionForm.get('AMC').setValue(res['paymentInfo']['hw_maintenance']);
        if (res['paymentInfo'] && res['paymentInfo']['calibration']) this.creditPerTransactionForm.get('AMC').setValue(res['paymentInfo']['calibration']);
      },
      err => {
        console.log('error adding credit per transaction', err)
      }
    )
  }
  

  addCreditPerTransactionExpert(){
    this.moderatorService.addPerTransactionCreditExpert({...this.creditPerTransactionFormExpert.getRawValue(), expertId:this.expert['_id']}).subscribe(
      res => {
       //console.log(res)
        window.alert('Credit/Transaction Update successful')
      },
      err => {
       //console.log('error adding creit per transaction', err)
      }
    )
  }


  getCreditPerTransactionExpert(){
    this.moderatorService.getPerTransactionCreditExpert({expertId:this.expert['_id']}).subscribe(
      res => {

        console.log(res)
        if (res['info'] && res['info']['perTransactionCredit'])
        this.creditPerTransactionFormExpert.get('credit').setValue(res['info']['perTransactionCredit']);
        // window.alert(res)
      },
      err => {
       //console.log('error adding creit per transaction', err)
      }
    )
  }

  sendInvoice(customerID, fullName){
    this.pdfLoading = true;
    this.moderatorService.sendInvoice(customerID)
    .then(resp => resp.arrayBuffer()).then(resp => {
      const file = new Blob([resp], {type: 'application/pdf'});
      // process to auto download it
      const fileURL = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = fileURL;
      link.download = customerID + '_' + fullName + '_' + this.datePipe.transform(Date.now(), 'yyyy-MM-dd') + ".pdf";
      link.click();
      this.pdfLoading = false;
    });
  }
}
